import {useEffect, useRef} from 'react';
import {CalculatorFormFields} from '../../../calculator/calculator.model';
import {CALCULATE_FIRST_PAYMENT_DATE_URL} from '../../../../../../../constants/api-urls';
import useGet from '../../../../../../../shared/hooks/use-get.hook';

export function useCalculateFirstPaymentDate(values: CalculatorFormFields,
                                             onFirstPaymentDateCalculated: (value, calculatedDate) => void): void {
  const getCalculateFirstPaymentDate = useGet<string>(CALCULATE_FIRST_PAYMENT_DATE_URL);
  const previousPaymentIntervalId = useRef(values.paymentIntervalId.value);

  useEffect(() => {
    const dateGranted = values.dateGranted.value;
    const paymentIntervalId = values.paymentIntervalId.value;
    const firstPaymentDate = values.firstPaymentDate?.value;

    if (dateGranted && paymentIntervalId) {
      const urlSearchParams = getUrlParams(dateGranted, paymentIntervalId.toString());
      getCalculateFirstPaymentDate(urlSearchParams).then(calculatedDate => {
        const paymentIntervalChanged = previousPaymentIntervalId.current !== paymentIntervalId;
        const dateToUse = paymentIntervalChanged || !firstPaymentDate ? calculatedDate : firstPaymentDate;
        const firstPaymentDateCopy = {...values.firstPaymentDate, value: dateToUse};
        onFirstPaymentDateCalculated(firstPaymentDateCopy, calculatedDate);
        previousPaymentIntervalId.current = paymentIntervalId;
      });
    }
  }, [values.dateGranted.value, values.paymentIntervalId.value]);
}

function getUrlParams(dateGranted: string, paymentIntervalId: string): URLSearchParams {
  const urlSearchParams = new URLSearchParams();
  urlSearchParams.set('grantDate', dateGranted);
  urlSearchParams.set('paymentIntervalId', paymentIntervalId);
  return urlSearchParams;
}
